import NotFoundView from '@/views/errors/404View.vue';
export const errorRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFoundView,
    meta: { guest: true }, // You can modify this as needed
  },
];
